import { useCallback } from "react";
import { Tag, Phase, PhaseCompletionStatus, PhaseCompletion } from "data/api";
import { PhaseCompletionStatusExtended, PhaseCompletionStatusIssue } from "data/api/extensions";
import { ShortenedPhaseInformation } from "components/TagList/types";
type TagStatusForPhase = (tag: Tag, phase: Phase) => ShortenedPhaseInformation;

export const getShortenedPhaseFromPhase = (
  status: PhaseCompletionStatusExtended,
  phase: Phase,
  phaseCompletion: PhaseCompletion
): ShortenedPhaseInformation => ({
  status,
  dateCompleted: phaseCompletion?.dateCompleted || null,
  completedByUser: phaseCompletion?.completedByUser || null,
  id: phase.id || 0,
  name: phase.name || "",
});

export const useTagStatus = (): TagStatusForPhase => {
  return useCallback((tag: Tag, phase: Phase) => {
    const phaseCompletion = (tag.phaseCompletions || []).find(
      (phaseCompletion) => phaseCompletion.phaseId === phase.id
    );

    if (!phaseCompletion) {
      return {
        status: PhaseCompletionStatus.NotStarted,
        completedByUser: null,
        dateCompleted: null,
        id: phase.id || 0,
        name: phase.name || "",
      };
    }

    const getPhaseInformation = (status: PhaseCompletionStatusExtended): ShortenedPhaseInformation =>
      getShortenedPhaseFromPhase(status, phase, phaseCompletion);

    if (phaseCompletion.phaseCompletionStatus === PhaseCompletionStatus.Completed) {
      return getPhaseInformation(PhaseCompletionStatus.Completed);
    } else if (phaseCompletion.phaseCompletionStatus === PhaseCompletionStatus.Excluded) {
      return getPhaseInformation(PhaseCompletionStatus.Excluded);
    }

    return getPhaseInformation(
      phaseCompletion.hasCriticalIssue
        ? PhaseCompletionStatusIssue.Issue
        : phaseCompletion.phaseCompletionStatus || PhaseCompletionStatus.NotStarted
    );
  }, []);
};
